<template>
  <div class="layout-topbar">
    <div class="content-container">
      <div>
        <router-link to="/dashboard/claim-debt">
          <img alt="LogoIcired" src="@/assets/blue-logo.svg" />
        </router-link>
        <a
          v-if="this.$store.state.codigoPromotor == this.promotorEinforma"
          :href="this.einformaURL"
        >
          <img
            class="logoEInforma"
            alt="LogoEinforma"
            src="@/assets/einforma_logo.svg"
          />
        </a>
      </div>
      <div class="slidingPanelButtonContainer">
        <slot></slot>
      </div>
      <div>
        <ul>
          <li
            v-for="item in menuItems"
            :key="item.name"
            @click="toggleProfile($event, item.name)"
          >
            <div
              v-if="!(item.order == 1 && $store.state.esMayorista)"
              @click="navigate(item.route, item.internal)"
            >
              <span :class="getSelectedBgColorClass(item.route)">
                <i :class="['pi', item.icon]" />
              </span>
              <p :class="getSelectedColorClass(item.route)">{{ item.name }}</p>
            </div>
          </li>
        </ul>
      </div>
      <OverlayPanel ref="profile" class="my-account pb-1">
        <ul
          v-for="(item, index) in menuItems[4].childs"
          :key="item.name"
          :class="`profile-menu ${index > 0 && 'not-first'}`"
          id="profileMenu"
          style=""
        >
          <li>
            <a
              @click="switchMiCuenta(item.name)"
              :class="['p-link', item.cssClass]"
            >
              <span class="iconContainer mr-2">
                <i :class="['pi', item.icon]"></i>
              </span>
              <span>{{ item.name }}</span>
            </a>
          </li>
        </ul>
      </OverlayPanel>
    </div>
  </div>
</template>

<script>
//Dependiendo de lo que se añada al item del perfil se borrará o no este componente
//import AppProfile from './AppProfile';
import MessagesMixin from "@/utils/messages";
import { GET_SUGGESTIONS_RECLAMACION } from "@/graphQLQueries/BusquedaQueries";
import { CODIGOS_PROMOCIONALES } from "@/resources/constants";
import RoutesMixin from "@/utils/routes";

export default {
  mixins: [MessagesMixin, RoutesMixin],
  components: {
    //'AppProfile': AppProfile
  },
  data() {
    return {
      promotorEinforma: CODIGOS_PROMOCIONALES.EINFORMA,
      searchQuery: "",
      searchSuggestions: [],
      size: 0,
      einformaURL: process.env.VUE_APP_EINFORMA_LINK_URL,
      menuItems: [
        {
          internal: true,
          order: 1,
          name: this.$i18n.t("menu.claims"),
          icon: "pi-file",
          route: { name: "dashboard", params: { tab: "claim-debt", index: 0 } },
        },
        {
          internal: true,
          order: 2,
          name: this.$i18n.t("menu.consultas"),
          icon: "pi-search",
          route: { name: "dashboard", params: { tab: "search-debt", index: 2 } },
        },
        {
          internal: false,
          order: 3,
          name: this.$i18n.t("menu.contact"),
          icon: "pi-envelope",
          route:
            process.env.VUE_APP_ZENDESK_BASE_URL + "/hc/es-es/requests/new",
        },
        {
          internal: false,
          order: 4,
          name: this.$i18n.t("menu.help"),
          icon: "pi-question",
          route: process.env.VUE_APP_ZENDESK_BASE_URL + "/hc/es-es",
        },
        {
          internal: false,
          order: 5,
          name: this.$i18n.t("menu.myAccount"),
          icon: "pi-user",
          route: "",
          childs: [
            {
              internal: true,
              name: this.$i18n.t("menu.profile"),
              icon: "pi-user",
              route: "",
              cssClass: "myAccountDesplegable",
            },
            {
              internal: true,
              name: this.$i18n.t("menu.invoices"),
              icon: "pi-file",
              route: "",
              cssClass: "myAccountDesplegable",
            },
            {
              internal: true,
              name: this.$i18n.t("menu.closeSession"),
              icon: "pi-sign-out",
              route: "",
              cssClass: "myAccountDesplegable logOut",
            },
          ],
        },
      ],
    };
  },
  computed: {
    skipQuery() {
      if (this.searchQuery && this.searchQuery.length > 3) return false;
      return true;
    },
  },
  methods: {
    search() {
      if (this.searchQuery === "") return;

      this.to({ name: "search", params: { term: this.searchQuery } });
    },
    searchSuggestion() {
      if (!this.searchQuery) return;
      this.$apollo.queries.searchSuggestions.refetch();
    },
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    navigate(route, internal) {
      if (route == "") return;

      if (internal) {
        this.to({
          name: route.name,
          params: route.params,
        });

        return;
      }

      window.open(route);
    },
    toggleProfile(event, name) {
      if (name == this.menuItems[4].name) this.$refs.profile.toggle(event);
    },
    switchMiCuenta(name) {
      if (name == this.menuItems[4].childs[0].name) this.perfil();
      if (name == this.menuItems[4].childs[1].name) this.invoices();
      if (name == this.menuItems[4].childs[2].name) this.logout();
    },
    perfil() {
      this.to({ name: "profile" });
    },
    invoices() {
      this.to({ name: "myInvoices" });
    },
    logout() {
      this.$keycloak.logout();
    },
    getSelectedColorClass(route) {
      return this.isSelectedClass(route) ? "selectedItem" : "";
    },
    getSelectedBgColorClass(route) {
      return this.isSelectedClass(route) ? "selectedBgItem" : "";
    },
    isSelectedClass(route) {
      if (route === "" || route.name === undefined) {
        return false;
      }

      if (route.name !== "dashboard" || this.$route.name !== "dashboard") {
        return false;
      }

      if (
        this.$route.params.tab === undefined &&
        route.params.tab == "claim-debt"
      ) {
        return true;
      }

      if (route.params.tab != this.$route.params.tab) {
        return false;
      }

      return true;
    },
  },
  apollo: {
    searchSuggestions: {
      query: GET_SUGGESTIONS_RECLAMACION,
      variables() {
        return {
          term: this.searchQuery,
          size: this.size,
        };
      },
      update(data) {
        if (data.searchReclamacion) {
          return data.searchReclamacion.suggestion;
        }
        this.addWarnMessage(this.$i18n.t("errores.search"));
      },
      skip() {
        return this.skipQuery;
      },
    },
  },
};
</script>

<style scoped>
  .layout-topbar ul li div span {
    padding: 0.6em;
  }
  .layout-topbar ul li div p {
    margin-top: 1em !important;
    letter-spacing: 0.3px;
  }
</style>